import React from "react";
import { Box, Container, Typography, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const TesvikHibeDanismanlik = () => {
    return (
        <Container maxWidth="md" sx={{ py: 5 }}>
            <Box textAlign="center" mb={4}>
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                    Teşvik ve Hibe Danışmanlığı
                </Typography>
            </Box>

            <Typography variant="body2" color="textPrimary" paragraph>
                İşletmelerin ihracat ve yeni ürünler geliştirme hedeflerine ulaşabilmesi için Devlet destekleri olmazsa olmazdır.
                Türkiye şu an gelişmekte olan ülkeler arasında gösterilmektedir, bunun yanında Avrupa Birliği uyum yasaları çerçevesinde esnafımıza
                ve işletmelerimize oldukça önemli destekler sunulmaktadır. Bu dönemde hızla gelişen ülkemizin yatırımcılara sunduğu hibe,
                destek ve teşviklerden sorunsuz bir şekilde faydalanmanızı garanti ediyoruz.
            </Typography>

            <Typography variant="body2" color="textPrimary" paragraph>
                Üretim sektörünün canlanması, ticari hayatın sürdürülebilirliği, gerekli para akışının sağlanabilmesi, gelir dağılımındaki
                adaletsizliğin önüne geçilebilmesi, ekonominin büyümesi gibi nedenlerle ülkeler hibe ve teşvik sistemini hayata geçirmiştir.
                Türkiye’de hibe, teşvik, proje ve devlet destekleri oldukça karmaşık bir yapıya sahiptir. Bu nedenle, şirketinizin ihtiyaçlarını,
                şirketinize daha uygun olabilecek hibe ve teşvikleri, izlenecek yolları değerlendirmek için fizibilite çalışması yapılması gerekmektedir.
            </Typography>

            <Typography variant="body2" color="textPrimary" paragraph>
                Türkiye’de pek çok bakanlığın hibe ve teşvik konularıyla ilgilendiğini bilmekteyiz. Bireysel ve Şirket şirketlerinin hibe,
                teşvik ve devlet desteklerinden faydalanarak ülke ekonomisine katkı sağlayacağına inanıyoruz.
            </Typography>

            <Typography variant="h6" fontWeight="bold" gutterBottom>
                Desteklenen Alanlar
            </Typography>
            <List>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Sosyal Güvenlik Kurumu Teşvikleri" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Hazine ve Maliye Bakanlığı Teşvikleri" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="İthalat ve İhracat Teşvikleri" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="İŞKUR Teşvikleri" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="KOSGEB Destekleri" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Ticaret Bakanlığı Hibe Destekleri" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="SGK Teşvik Destekleri" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
            </List>

            <Typography variant="h6" fontWeight="bold" gutterBottom>
                Vergi ve Mali Danışmanlık
            </Typography>
            <Typography variant="body1" color="textPrimary" paragraph>
                Şirketiniz için vergisel riskleri minimize etme ve avantajları yakalama imkânı ancak doğru ve zamanında müdahale ile mümkündür.
            </Typography>

            <List>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Kurumlar vergisi ve gelir vergisi" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Vergi stopajı" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Katma değer vergisi, özel tüketim vergisi, damga vergisi, BSMV ve KKDF gibi işlem üzerinden alınan vergiler" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Uluslararası vergi anlaşmaları" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Yatırım teşvikleri" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
            </List>
        </Container>
    );
};

export default TesvikHibeDanismanlik;
